import apiClient from '@/utils/client'
import requestUrl from '@/config'

const mediaReturn = {
  actions: {
    // UC回传
    fetchUcMediaReturn(action, params) {
      return apiClient.postWithSignJson(requestUrl.UC_RETURN, params, true)
    },
    // 百度回传
    fetchBaiduMediaReturn(action, params) {
      return apiClient.postWithSignJson(requestUrl.BAIDU_RETURN, params, true)
    },
    // MP回传
    fetchMpMediaReturn(action, params) {
      return apiClient.postWithSign(requestUrl.MP_RETURN, params, true)
    },
    // GDT回传
    fetchGdtMediaReturn(action, params) {
      return apiClient.postWithSign(requestUrl.GDT_RETURN, params, true)
    },
    // 头条回传
    fetchToutiaoMediaReturn(action, params) {
      return apiClient.postWithSignJson(requestUrl.TOUTIAO_RETURN, params, true)
    },
    // 360PC回传
    fetch360MediaReturn(action, params) {
      return apiClient.postWithSignJson(requestUrl.PC_360_RETURN, params, true)
    },
    // 快手回传
    fetchKuaishouMediaReturn(action, params) {
      return apiClient.postWithSignJson(
        requestUrl.KUAISHOU_RETURN,
        params,
        true
      )
    },
    // 微博回传
    fetchWeiboMediaReturn(action, params) {
      return apiClient.postWithSignJson(requestUrl.WEIBO_RETURN, params, true)
    },
  },
}

export default mediaReturn
